import parameterMetadata from "./parameterMetadata";

export default {
  presets: "",

  f: parameterMetadata.f.initial,
  k: parameterMetadata.k.initial,
  dA: parameterMetadata.dA.initial,
  dB: parameterMetadata.dB.initial,
  timestep: parameterMetadata.timestep.initial,

  seed: {
    type: 0,
    circle: { radius: 100 },
    square: { width: 200, height: 200, rotation: 0 },
    text: { value: "Reaction diffusion", size: 85, rotation: 0 },
    image: {
      filename: "",
      image: null,
      fit: 0,
      scale: 1.0,
      rotation: 0,
    },
    randomPoints: { minCount: 2, maxCount: 3, radius: 56 },
  },

  useSmoothing: true,

  /** Full-screen display: blur (px sigma) and CA offset (px) applied after reaction–diffusion. */
  postProcess: {
    blurRadius: 5.5,
    chromaticAberration: 2,
  },

  twoToneColors: {
    colorHighRGB: { r: 209, g: 255, b: 71 },
    colorLowRGB: { r: 0, g: 0, b: 0 },
  },

  canvas: {
    width: parameterMetadata.canvas.width.initial,
    height: parameterMetadata.canvas.height.initial,
    scale: parameterMetadata.canvas.scale.initial,
    isMaximized: true,
  },

  styleMap: {
    imageLoaded: false,
    scale: 1.0,
    rotation: 0,
    translate: { x: 0.0, y: 0.0 },
    f: parameterMetadata.f.initial,
    k: parameterMetadata.k.initial,
    dA: parameterMetadata.dA.initial,
    dB: parameterMetadata.dB.initial,
    animation: {
      enabled: false,
      parameter: "",
      easingEquation: "",
      speed: 1.0,
    },
  },

  bias: {
    x: parameterMetadata.bias.x.initial,
    y: parameterMetadata.bias.y.initial,
  },

  mask: {
    enabled: true,
    text: "g",
    textSize: 512,
    fontFamily: "Syne Mono",
  },
};
